import { render } from "./CusDialog.vue?vue&type=template&id=a5ef4454&scoped=true"
import script from "./CusDialog.vue?vue&type=script&lang=js"
export * from "./CusDialog.vue?vue&type=script&lang=js"

import "./CusDialog.vue?vue&type=style&index=0&id=a5ef4454&lang=scss&scoped=true"

import exportComponent from "/Users/ilss0902/PorjectCenter/Cloudmobile/雲端POS_V2/code/dayungs_pos_web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5ef4454"]])

export default __exports__